import { createContext, useContextSelector } from 'use-context-selector'
import {Certificate} from '../../../../../../lib/apollo/types'

export interface TalentCardContextType {
  certificate?: Certificate
  onClick?: () => void
  clubImg?: string
  schoolImg?: string
}

export const TalentCardContext = createContext<TalentCardContextType>({})

export const useTalentCardContext = (): TalentCardContextType => useContextSelector(TalentCardContext, ctx => ctx)
